<div class="container-fluid " *ngIf="!loading">
  <div class="row">
    <div class="col s12">
      <h1 class="mb-1">Dashboard</h1>
      <span class="block mt-[3px] text-gray-400 !text-[16px]">Welcome back, here's what's happening today.</span>
    </div>
  </div>

  <div class="row" *ngIf="showSetupBanner">
    <div class="col s12">
      <div class="setup-banner">
        <div class="setup-banner__content">
          <span class="material-symbols-outlined setup-banner__icon">rocket_launch</span>
          <div class="setup-banner__text">
            <div class="setup-banner__title">Finish setup to start seeing real activity</div>
            <div class="setup-banner__subtitle">
              Add an employee, install the agent, and capture your first screenshot — you can resume anytime.
            </div>
          </div>
        </div>
        <div class="setup-banner__actions setup-banner__actions--wrap">
          <button mat-raised-button color="primary" (click)="resumeSetup()">
            Resume setup
          </button>
          <!-- <button mat-stroked-button type="button" (click)="takeProductTour()">
            Take tour
          </button> -->
          <button mat-stroked-button type="button" (click)="tryDemoData()"
            *ngIf="trialOnboardingHelp.canShowOptionalHelpLinks()">
            {{ trialOnboardingHelp.isShowingDemoData() ? 'Hide' : 'Try' }} sample data
          </button>
          <button mat-stroked-button (click)="dismissSetupBanner()">
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="row employee-cards db-style-1" tourAnchor="DashboardInforMativeCard">
    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>
      <mat-card *ngIf="!isloading" class="total-employee-card" id="total_employee_section"
        (click)="routeToFilterEmployee('all')">
        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div class="employee-card-icon-div employee-card-icon-div-bg-total employee-card-icon-div-color-total">
                <span class="material-symbols-outlined"> group </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-total db-style-3">
                {{ isTourActive() ? onlineUsers + offlineUsers + idleUsers : 100 }}
              </h1>
            </div>
          </div>
          <div class="row db-style-4">
            <div class="col s12 m6 l6 xl6">
              <p class="employee-card-icon-div-color-total padding_text">Employees</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>

      <mat-card *ngIf="!isloading" class="total-employee-card" [matMenuTriggerFor]="tooltipOnline"
        (click)="routeToFilterEmployee('online')" #onlineMenuTrigger="matMenuTrigger" (mouseenter)="openOnlineMenu()">
        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div class="employee-card-icon-div employee-card-icon-div-bg-online employee-card-icon-div-color-online">
                <span class="material-symbols-outlined"> person </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-online">{{ isTourActive() ? onlineUsers : 100 }}</h1>
            </div>
          </div>
          <div class="row db-style-5">
            <div class="col s12">
              <p class="employee-card-icon-div-color-online">Online</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-menu #tooltipOnline="matMenu" class="custom-tooltip-count" [overlapTrigger]="false"
        (mouseenter)="cancelCloseTimer()">
        <div class="tooltip-content db-style-7">
          <p><b>Online Employees</b></p>
          <ul>
            <li *ngFor="let employee of onlineEmployee">{{employee.wpEmployee.name}}</li>
            <li *ngIf="!onlineEmployee || !onlineEmployee.length">No user online</li>
          </ul>
        </div>
      </mat-menu>
    </div> 
    
    IDLE EMPLOYEES CARD 
    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>

      <mat-card *ngIf="!isloading" class="total-employee-card" [matMenuTriggerFor]="tooltipIdle"
        #idleMenuTrigger="matMenuTrigger" (mouseenter)="openIdleMenu()">
        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div
                class="employee-card-icon-div employee-card-icon-div-bg-idle employee-card-icon-div-color-idle">
                <span class="material-symbols-outlined"> timer </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-idle">{{ isTourActive() ? idleUsers : 100 }}</h1>
            </div>
          </div>
          <div class="row db-style-5">
            <div class="col s12">
              <p class="employee-card-icon-div-color-idle">Idle</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-menu #tooltipIdle="matMenu" class="custom-tooltip-count" [overlapTrigger]="false"
        (mouseenter)="cancelCloseTimer()">
        <div class="tooltip-content db-style-7">
          <p><b>Idle Employees</b></p>
          <ul>
            <li *ngFor="let employee of idleEmployee">
              {{employee.wpEmployee.name}}
              <span *ngIf="getIdleStartTime(employee)" style="color: #666; font-size: 0.9em; margin-left: 8px;">
                (Idle since {{getIdleStartTime(employee)}})
              </span>
            </li>
            <li *ngIf="!idleEmployee || !idleEmployee.length">No user idle</li>
          </ul>
        </div>
      </mat-menu>
    </div>
    
    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>

      <mat-card *ngIf="!isloading" class="total-employee-card" [matMenuTriggerFor]="tooltipOffline"
        (click)="routeToFilterEmployee('offline')" #offlineMenuTrigger="matMenuTrigger"
        (mouseenter)="openOfflineMenu()">

        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div
                class="employee-card-icon-div employee-card-icon-div-bg-offline employee-card-icon-div-color-offline">
                <span class="material-symbols-outlined"> person_off </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-offline">{{ isTourActive() ? offlineUsers : 100 }}</h1>
            </div>
          </div>
          <div class="row db-style-5">
            <div class="col s12">
              <p class="employee-card-icon-div-color-offline">Offline</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-menu #tooltipOffline="matMenu" class="custom-tooltip-count" [overlapTrigger]="false"
        (mouseenter)="cancelCloseTimer()">
        <div class="tooltip-content db-style-7">
          <p><b>Offline Employees</b></p>
          <ul>
            <li *ngFor="let employee of offlineEmployee">
              {{employee.wpEmployee.name}}
              <span *ngIf="isInvitedUser(employee)" style="color: #d1a600; font-size: 0.9em; margin-left: 8px;">
                (Invited)
              </span>
              <span *ngIf="!isInvitedUser(employee) && getOfflineLastActiveTime(employee)" style="color: #666; font-size: 0.9em; margin-left: 8px;">
                (Last active {{getOfflineLastActiveTime(employee)}})
              </span>
            </li>
            <li *ngIf="!offlineEmployee || !offlineEmployee.length">No user offline</li>
          </ul>
        </div>
      </mat-menu>
    </div>

    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>
      <mat-card *ngIf="!isloading" class="total-employee-card">
        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div class="employee-card-icon-div employee-card-icon-div-bg-team employee-card-icon-div-color-team">
                <span class="material-symbols-outlined"> groups </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-team db-style-3">
                {{isTourActive() ? teamSize : 100}}
              </h1>
            </div>
          </div>
          <div class="row db-style-4">
            <div class="col s6">
              <p class="employee-card-icon-div-color-team padding_text db-style-8">
                Teams
              </p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div> -->

  <div class="px-3 mb-5 w-full flex items-center gap-4 justify-between sm:flex-nowrap">
    <div class="flex items-center gap-4 justify-between w-full flex-wrap">
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#5459d1'" [backgroundColorIcon]="'#5459d130'"
        [iconName]="'group'" [cardTitle]="'Employees'" [buttonTitle]="'View All'"
        [cardCount]="isTourActive() ? allUsersCount : 100" [loading]="isloading" [routingPath]="'all'"
        [isShowTooltip]="false" [isShowQuota]="quotaAllowedToCreateUser"></status-card>
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#21bc68'" [backgroundColorIcon]="'#e0f0e78c'"
        [iconName]="'person'" [cardTitle]="'Online'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? onlineUsersForCard.length : 100" [loading]="isloading" [routingPath]="'online'"
        [isShowTooltip]="true" [toolTipContent]="onlineUsersForCard"></status-card>
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#bc214f'" [backgroundColorIcon]="'#bc214f1a'"
        [iconName]="'person_off'" [cardTitle]="'Offline'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? offlineUsersForCard.length : 100" [loading]="isloading"
        [routingPath]="'offline&auto-logout'" [isShowTooltip]="true"
        [toolTipContent]="offlineUsersForCard"></status-card>
    </div>
    <div class="flex items-center gap-4 justify-between w-full flex-wrap">
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#ff9900'" [backgroundColorIcon]="'#ff99001a'"
        [iconName]="'timer'" [cardTitle]="'Idle'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? idleUsersForCard.length : 100" [loading]="isloading" [routingPath]="'idle'"
        [isShowTooltip]="true" [toolTipContent]="idleUsersForCard"></status-card>
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#ff0000'" [backgroundColorIcon]="'#ff00001a'"
        [iconName]="'person_cancel'" [cardTitle]="'Absent'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? absentUsersList.length : 100" [loading]="isloading" [isShowTooltip]="true"
        [toolTipContent]="absentUsersList" [routingPath]="'absent'"></status-card>
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#e2b300'" [backgroundColorIcon]="'#f9c80e1a'"
        [iconName]="'person_add'" [cardTitle]="'Invited'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? invitedUsersList.length : 100" [loading]="isloading" [routingPath]="'invited'"
        [isShowTooltip]="true" [toolTipContent]="invitedUsersList"></status-card>
    </div>
  </div>

  <div class="row" id="most_used_apps_section" tourAnchor="mostUsedAppDashboard">
    <div class="col s12 m6 lg12 xl6 db-style-9">
      <mat-card class="graph-card">
        <div class="row most-use-row">
          <div class="col s12 lg6">
            <h4>Most Used application</h4>
          </div>
          <div class="col s12 lg6 db-style-10">
            <mat-form-field class="date-range-picker-form-field">
              <mat-date-range-input [disabled]="!isTourActive()" [rangePicker]="picker" [min]="minApplicationUsageDate"
                [max]="maxApplicationUsageDate">
                <input matStartDate [value]="startdate" placeholder="Start date"
                  (dateChange)="onStartDateChange($event)" />
                <input matEndDate [value]="enddate" placeholder="End date" (dateChange)="onEndDateChange($event)" />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>
        <mat-card-content class="most-use-card-content">
          <div *ngIf="isPiechartLoad">
            <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
              [theme]="{ 'border-radius': '2', height: '600px', margin: '5px' }"></ngx-skeleton-loader>
          </div>
          <div class="row application-usage-container"
            [ngStyle]="{'display':isPiechartLoad ? 'none':'block','visibility':isPiechartLoad?'hidden':'visible'}">
            <div class="col s12">
              <div class="db-style-11">
                <application-usage [isChartWebBrowserUser]="false"></application-usage>
              </div>
            </div>
            <div class="col s12 progressbar-component db-style-12">
              <progressbar [isDashboard]="true" [isDataWebsiteUsage]="false"></progressbar>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div>
      </div>
    </div>

    <!-- This will come later when website usage comes for release -->
    <div class="col s12 m6 lg12 xl6 db-style-9">
      <mat-card class="graph-card">
        <div class="row most-use-row">
          <div class="col s12 lg6 most-use-contain">
            <h4 class="title-with-beta">
              <span>Most Used Websites</span>
              <span class="beta-badge" *ngIf="sysConfig.isBeta" [matTooltip]="sysConfig.betaTooltip">
                <i>Beta</i>
              </span>
            </h4>
          </div>
          <div class="col s12 lg6 db-style-10">
            <mat-form-field class="date-range-picker-form-field">
              <mat-date-range-input [disabled]="!isTourActive()" [rangePicker]="pickerWebsiteUsage"
                [min]="minWebsiteUsageDate" [max]="maxWebsiteUsageDate">
                <input matStartDate [value]="startDateForInput" placeholder="Start date"
                  (dateChange)="onStartDateChangeWebsiteUsageChart($event)" />
                <input matEndDate [value]="endDateForInput" placeholder="End date"
                  (dateChange)="onEndDateChangeWebsiteUsageChart($event)" />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="pickerWebsiteUsage"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerWebsiteUsage></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

        <mat-card-content class="most-use-card-content">
          <div *ngIf="isPieChartLoadWebsite">
            <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
              [theme]="{ 'border-radius': '2', height: '600px', margin: '5px' }"></ngx-skeleton-loader>
          </div>
          <div class="row application-usage-container"
            [ngStyle]="{'display':isPieChartLoadWebsite ? 'none':'block','visibility':isPieChartLoadWebsite?'hidden':'visible'}">
            <div class="col s12">
              <div class="db-style-11">
                <application-usage [isChartWebBrowserUser]="true"></application-usage>
              </div>
            </div>
            <div class="col s12 progressbar-component db-style-12">
              <progressbar [isDashboard]="true" [isDataWebsiteUsage]="true"></progressbar>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col s12">
      <!-- Removed because we show a separate button for screenshots and time line is a single tab -->
      <!-- <button mat-stroked-button class="timeline-section-btn {{ timelineBackground }}"
        (click)="getDashboardSection('timeline')">
        Timeline
      </button> -->

      <!-- Removed because we show a separate button for screenshots -->
      <!-- <button id="screenShotSection" tourAnchor="ScreenShotDashboard" mat-stroked-button
        class="timeline-section-btn {{ screenshotBackground }}" (click)="getDashboardSection('screenshot')">
        Screen Shots
      </button> -->
    </div>
  </div>

  <div class="row" *ngIf="timelineSection" id="timeline_section" tourAnchor="TimelineDashboard">
    <div class="col s12">
      <mat-card class="fluid-ss timeline-card">
        <div class="timeline-filter-header">
          <div class="filter-header">
            <h4>
              Employees Work Timeline
            </h4>

            <div class="filter-options timeline-toolbar">
              <div class="timeline-toolbar__modes">
                <div class="timeline-datepicker view-mode-toggle db-style-10" aria-label="Timeline range length">
                  <button mat-button type="button" class="mode-btn" [class.active]="isSingleDayActive"
                    (click)="setSingleDay()" matTooltip="Single day (24 hours)">
                    24 Hours
                  </button>
                  <button mat-button type="button" class="mode-btn" [class.active]="isVirtualShiftActive"
                    (click)="setVirtualShift()" matTooltip="Two calendar days (48 hours)">
                    48 Hours
                  </button>
                </div>
              </div>

              <div class="timeline-toolbar__shift">
                <div class="shift-time-picker">
                  <div class="shift-time-picker-content-wrapper">
                    <div class="shift-time-field-group">
                      <span class="shift-time-field-group__caption" id="timeline-shift-start-caption">Shift Start</span>
                      <mat-form-field appearance="fill" floatLabel="never"
                        class="date-range-picker-form-field shift-time-mat-field" subscriptSizing="dynamic">
                        <input matInput type="time" step="300" aria-labelledby="timeline-shift-start-caption"
                          [(ngModel)]="timelineStartTime" (ngModelChange)="scheduleTimelineShiftTimeFilterApply()">
                      </mat-form-field>
                    </div>
                    <div class="shift-time-field-group">
                      <span class="shift-time-field-group__caption" id="timeline-shift-end-caption">Shift End</span>
                      <mat-form-field appearance="fill" floatLabel="never"
                        class="date-range-picker-form-field shift-time-mat-field" subscriptSizing="dynamic">
                        <input matInput type="time" step="300" aria-labelledby="timeline-shift-end-caption"
                          [(ngModel)]="timelineEndTime" (ngModelChange)="scheduleTimelineShiftTimeFilterApply()">
                      </mat-form-field>
                    </div>
                  </div>
                  <button mat-stroked-button type="button" color="primary" class="shift-clear-btn"
                    (click)="clearTimelineShiftSelection()" [disabled]="!hasTimelineShiftSelection">
                    Clear
                  </button>
                </div>
              </div>

              <div class="timeline-toolbar__date">
                <div class="timeline-date-nav" role="group" aria-label="Timeline date">
                  <button type="button" mat-icon-button class="timeline-nav-btn" [disabled]="_isStackbarLoading"
                    (click)="onPreviousDate()" matTooltip="Previous day">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                  </button>
                  <mat-form-field *ngIf="isSingleDayActive"
                    class="date-range-picker-form-field timeline-date-field timeline-date-field--single"
                    subscriptSizing="dynamic">
                    <input matInput [matDatepicker]="timelineSingleDp" [ngModel]="timelineSingleDayModel"
                      (ngModelChange)="onTimelineSingleDayPicked($event)" [min]="timelineMinDate"
                      [max]="timelineMaxDate" placeholder="Date" readonly>
                    <mat-datepicker-toggle matIconSuffix [for]="timelineSingleDp"></mat-datepicker-toggle>
                    <mat-datepicker #timelineSingleDp></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field *ngIf="!isSingleDayActive"
                    class="date-range-picker-form-field timeline-date-field timeline-date-field--range"
                    subscriptSizing="dynamic">
                    <mat-date-range-input [formGroup]="timeline48Range" [rangePicker]="timelineRangeDp"
                      [min]="timelineMinDate" [max]="timelineMatRangeMax">
                      <input matStartDate formControlName="start" placeholder="Start date" readonly>
                      <input matEndDate formControlName="end" placeholder="End date" readonly>
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="timelineRangeDp"></mat-datepicker-toggle>
                    <mat-date-range-picker #timelineRangeDp
                      (closed)="onTimeline48RangeClosed()"></mat-date-range-picker>
                  </mat-form-field>
                  <button type="button" mat-icon-button class="timeline-nav-btn" [disabled]="_isStackbarLoading"
                    (click)="onNextDate()" matTooltip="Next day">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-options">
            <div class="filter-partition">
              <!-- Legacy duplicate shift / date controls removed. -->
            </div>

            <div class="filter-partition">
              <!-- Team selection -->
              <mat-form-field class="timeline-datepicker">
                <mat-select placeholder="Select Team" (selectionChange)="teamSelectionChange()"
                  [(ngModel)]="selectedTeam" [disabled]="!isTourActive()" style="font-size: 15px;">
                  @for (team of teamsListForFilter; track $index) {
                  <mat-option [value]="team.title.rendered" (click)="teamSelected(team)">
                    {{team.title.rendered}}
                  </mat-option>
                  } @empty {
                  <mat-option disabled>No Teams Available</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <!-- Employee search component -->
              <app-employee-search [userList]="userList" [placeholder]="'Search Employee'" [isNeedUserReturn]="true"
                class="!w-full" [isInputSearch]="true" [selectedEmployeeId]="searchStack"
                (searchEmployeeName)="searchTimelineData($event)">
              </app-employee-search>
            </div>
          </div>
        </div>

        <div *ngIf="_isStackbarLoading">
          <ngx-skeleton-loader style="margin: 20px 0px; width: 100%" [theme]="{
              'border-radius': '2',
              height: '400px',
              margin: '5px'
            }"></ngx-skeleton-loader>
        </div>

        <!-- Virtual Shift Timeline Header - Aligned with chart data area -->
        <div class="chart-parent-div">
          <app-stacked-chart *ngIf="
            stackedChartData && stackedChartData.length && !_isStackbarLoading
          " [type]="'horizontal'" [data]="stackedChartData" [minValue]="x_min" [maxValue]="x_max"
            [labels]="stackedChartlabel" [tempDataTooltip]="tempDataTooltip" [newSessionData]="newSessionTimeline"
            [id]="stackedChartIds" [startDate]="timelineChartStartLocal" [endDate]="timelineChartEndLocal"
            [workingHoursStart]="timelineStartTime" [workingHoursEnd]="timelineEndTime"
            [attr.data-key]="page + '_' + selectedTeam + '_' + searchStack + '_' + (isSingleDayActive ? '24h' : '48h') + '_' + (timelineChartStartLocal || '') + '_' + (timelineChartEndLocal || '')"></app-stacked-chart>
        </div>

        <div></div>

        <div class="empty_list z-depth-2 remove-border" *ngIf="
            !_isStackbarLoading && stackedChartData && !stackedChartData.length
          ">
          <img src="assets/images/empty_list.png" alt="empty list image" />
        </div>
        <div class="row">
          <div class="timelin-pagination-div" *ngIf="totalStack_user && totalStack_user != 0">
            <div class="timeline-pagination">
              <p>{{startPage}}-{{endPage}} of {{totalStack_user}}</p>
            </div>
            <button (click)="WeekPrevNextAction(true)">
              <i class="material-icons db-style-19" [ariaDisabled]="page == 1">keyboard_arrow_left</i>
            </button>
            <button (click)="WeekPrevNextAction(false)">
              <i class="material-icons db-style-19">keyboard_arrow_right</i>
            </button>
          </div>
        </div>

      </mat-card>
    </div>
  </div>

  <!-- Conduct Task-Time Logs Section -->
  <div class="row" *ngIf="isConductIntegrated" id="conduct_timelogs_section">
    <div class="col s12">
      <mat-card class="fluid-ss" style="margin-bottom: 24px;">
        <mat-card-content style="padding: 20px;">
          <div
            style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; border-bottom: 1px solid #e2e8f0; padding-bottom: 12px;">
            <div style="display: flex; align-items: center; gap: 12px;">
              <span
                style="display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 8px; background-color: rgba(84, 89, 209, 0.1); color: #5459d1;">
                <span class="material-symbols-outlined" style="font-size: 20px;">schedule</span>
              </span>
              <div>
                <h3
                  style="margin: 0; font-size: 18px; font-weight: 600; color: #1e293b; display: flex; align-items: center; gap: 8px;">
                  Conduct Task-Time Logs
                  <span
                    style="padding: 2px 8px; font-size: 12px; font-weight: 500; background-color: rgba(84, 89, 209, 0.1); color: #5459d1; border-radius: 9999px;">
                    {{ conductTimelogs.length }} Entries ({{ groupedConductTimelogs.length }} Users)
                  </span>
                </h3>
                <span style="font-size: 12px; color: #94a3b8;">Task-time context retrieved from connected Conduct workspace</span>
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
              <div class="timeline-date-nav" role="group" aria-label="Conduct log date">
                <button type="button" mat-icon-button class="timeline-nav-btn" [disabled]="isImportingConductTimelogs"
                  (click)="onConductPreviousDate()" matTooltip="Previous day">
                  <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
                <mat-form-field class="date-range-picker-form-field timeline-date-field timeline-date-field--single" subscriptSizing="dynamic">
                  <input matInput [matDatepicker]="conductDp" [ngModel]="conductDateModel"
                    (ngModelChange)="onConductDatePicked($event)" placeholder="Date" readonly>
                  <mat-datepicker-toggle matIconSuffix [for]="conductDp"></mat-datepicker-toggle>
                  <mat-datepicker #conductDp></mat-datepicker>
                </mat-form-field>
                <button type="button" mat-icon-button class="timeline-nav-btn" [disabled]="isImportingConductTimelogs"
                  (click)="onConductNextDate()" matTooltip="Next day">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </div>

              <button mat-stroked-button color="primary" (click)="fetchConductTimelogs(true)"
                [disabled]="isImportingConductTimelogs"
                style="height: 36px; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 0 16px; border-color: #5459d1; color: #5459d1; font-weight: 500; border-radius: 6px;">
                <mat-spinner *ngIf="isImportingConductTimelogs" diameter="18" style="margin-right: 4px;"></mat-spinner>
                <span class="material-symbols-outlined" [class.animate-spin]="isImportingConductTimelogs"
                  style="font-size: 18px; display: inline-flex; align-items: center; justify-content: center; line-height: 1;">sync</span>
                <span style="font-size: 13px; line-height: 1;">Fetch Conduct Logs</span>
              </button>
            </div>
          </div>

          <div style="overflow-x: auto;">
            <table style="width: 100%; text-align: left; border-collapse: collapse; font-size: 14px;">
              <thead>
                <tr
                  style="background-color: #f8fafc; border-bottom: 2px solid #e2e8f0; color: #475569; font-weight: 700; text-transform: uppercase; font-size: 12px; letter-spacing: 0.05em;">
                  <th style="padding: 12px 14px; width: 40px;"></th>
                  <th style="padding: 12px 14px;">Employee</th>
                  <th style="padding: 12px 14px;">Logs Count</th>
                  <th style="padding: 12px 14px;">Total Hours Worked</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let group of groupedConductTimelogs">
                  <!-- Main Accordion Row -->
                  <tr (click)="toggleConductGroup(group)"
                    style="cursor: pointer; background-color: #ffffff; border-bottom: 1px solid #e2e8f0; transition: background-color 0.15s ease;">
                    <td style="padding: 14px; text-align: center; color: #475569;">
                      <span class="material-symbols-outlined" style="font-size: 22px; transition: transform 0.2s ease; display: inline-block; vertical-align: middle;"
                        [style.transform]="group.expanded ? 'rotate(90deg)' : 'rotate(0deg)'">
                        chevron_right
                      </span>
                    </td>
                    <td style="padding: 14px; font-weight: 600; color: #0f172a;">
                      <div style="display: flex; flex-direction: column; gap: 2px;">
                        <span style="font-weight: 700; color: #0f172a; font-size: 15px;">{{ group.employee_name }}</span>
                        <span style="font-size: 12px; color: #64748b; font-weight: 400;" *ngIf="group.employee_email">{{ group.employee_email }}</span>
                      </div>
                    </td>
                    <td style="padding: 14px;">
                      <span style="display: inline-flex; align-items: center; padding: 4px 12px; border-radius: 9999px; font-size: 13px; font-weight: 600; background-color: rgba(84, 89, 209, 0.1); color: #5459d1;">
                        {{ group.logs.length }} {{ group.logs.length === 1 ? 'Log' : 'Logs' }}
                      </span>
                    </td>
                    <td style="padding: 14px;">
                      <span style="display: inline-flex; align-items: center; padding: 5px 14px; border-radius: 6px; font-size: 14px; font-family: monospace; font-weight: 700; background-color: #d1fae5; color: #065f46; border: 1px solid #a7f3d0;">
                        {{ group.total_worked_hours }}
                      </span>
                    </td>
                  </tr>

                  <!-- Expanded Full Width Child Table -->
                  <tr *ngIf="group.expanded">
                    <td colspan="4" style="padding: 0; background-color: #f8fafc;">
                      <div style="width: 100%; border-top: 1px solid #e2e8f0; border-bottom: 2px solid #e2e8f0; background-color: #f8fafc;">
                        <table style="width: 100%; text-align: left; border-collapse: collapse; font-size: 13px;">
                          <thead>
                            <tr style="background-color: #f1f5f9; border-bottom: 1px solid #cbd5e1; color: #334155; font-weight: 700; text-transform: uppercase; font-size: 11px; letter-spacing: 0.05em;">
                              <th style="padding: 10px 16px; padding-left: 54px; width: 140px;">Project</th>
                              <th style="padding: 10px 16px; max-width: 320px; width: 320px;">Task Title</th>
                              <th style="padding: 10px 16px; width: 110px; white-space: nowrap;">Date</th>
                              <th style="padding: 10px 16px; width: 150px; white-space: nowrap;">Time Window</th>
                              <th style="padding: 10px 16px; width: 120px; white-space: nowrap;">Duration</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let log of group.logs" style="border-bottom: 1px solid #e2e8f0; background-color: #ffffff;">
                              <td style="padding: 12px 16px; padding-left: 54px;">
                                <span style="display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 6px; font-size: 12px; font-weight: 600; background-color: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe;">
                                  {{ log.project_name || 'General Project' }}
                                </span>
                              </td>
                              <td style="padding: 12px 16px; color: #1e293b; max-width: 320px; width: 320px; word-break: break-word;">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                  <span *ngIf="log.task_unique_id"
                                    style="font-size: 11px; font-family: monospace; font-weight: 600; padding: 2px 6px; background-color: #e2e8f0; color: #1e293b; border-radius: 4px; flex-shrink: 0;">
                                    {{ log.task_unique_id }}
                                  </span>
                                  <span style="font-weight: 600; font-size: 13px; color: #0f172a; line-height: 1.4;">{{ log.task_title || 'General Log' }}</span>
                                </div>
                              </td>
                              <td style="padding: 12px 16px; color: #334155; font-family: monospace; font-size: 13px; font-weight: 500; width: 110px; white-space: nowrap;">{{ log.date || log.log_date }}</td>
                              <td style="padding: 12px 16px; color: #334155; font-size: 13px; font-weight: 500; width: 150px; white-space: nowrap;">{{ log.from_time || '—' }} - {{ log.end_time || '—' }}</td>
                              <td style="padding: 12px 16px; width: 120px; white-space: nowrap;">
                                <span style="display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 6px; font-size: 13px; font-family: monospace; font-weight: 700; background-color: #ecfdf5; color: #047857; border: 1px solid #a7f3d0;">
                                  {{ log.worked_hours || '00:00:00' }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="!isImportingConductTimelogs && (!groupedConductTimelogs || groupedConductTimelogs.length === 0)">
                  <td colspan="4" style="padding: 24px; text-align: center; color: #94a3b8; font-style: italic;">
                    No Conduct task timelogs available for this date.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <mat-card class="fluid-ss screenshot-dashbord-card" *ngIf="screenshotSection" id="ss_section">
    <div class="row ss-fluid-row most-use-row">
      <div class="col s12 m12 most-use-contain db-style-1"
        style="display: flex; align-items: center; justify-content: space-between;">
        <h4 *ngIf="!selectEnable" style="margin: 0;">Screenshots</h4>

        <div class="filter-section d-flex items-center">
          <mat-form-field class="filter-search" appearance="fill">
            <mat-label>Employees</mat-label>
            <mat-select placeholder="Select Employees" [formControl]="employeeMultiCtrl">
              <mat-option value="">All Employees</mat-option>
              <mat-option *ngFor="let user of userList" [value]="user.id">{{user.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="timePicker screenshot-mat-datetime-filter">
            <mat-form-field appearance="fill" floatLabel="always"
              class="screenshot-range-field date-range-picker-form-field" subscriptSizing="dynamic">
              <mat-label>Date range</mat-label>
              <mat-date-range-input [formGroup]="screenshotDateRange" [rangePicker]="screenshotRangeDp"
                [min]="timelineMinDate" [max]="timelineMaxDate">
                <input matStartDate formControlName="start" placeholder="Start" readonly>
                <input matEndDate formControlName="end" placeholder="End" readonly>
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="screenshotRangeDp"></mat-datepicker-toggle>
              <mat-date-range-picker #screenshotRangeDp
                (closed)="onDashboardScreenshotFilterChange()"></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="always"
              class="screenshot-time-field date-range-picker-form-field" subscriptSizing="dynamic">
              <mat-label>Start time</mat-label>
              <input matInput type="time" step="1" [(ngModel)]="screenshotStartTimeStr"
                (change)="onDashboardScreenshotFilterChange()">
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="always"
              class="screenshot-time-field date-range-picker-form-field" subscriptSizing="dynamic">
              <mat-label>End time</mat-label>
              <input matInput type="time" step="1" [(ngModel)]="screenshotEndTimeStr"
                (change)="onDashboardScreenshotFilterChange()">
            </mat-form-field>
            <mat-icon class="datepicker-open-trigger db-style-20" (click)="openDatepicker()">today</mat-icon>
          </div>
        </div>

      </div>
    </div>

    <div class="screenshot-time-hint" *ngIf="screenshotSection && regionHint" role="note">
      <mat-icon class="hint-icon" fontSet="material-symbols-outlined">public</mat-icon>
      <span class="hint-text">{{ regionHint }}</span>
    </div>

    <div *ngIf="isloading">
      <div class="row">
        <div class="col s12 m6 l3" *ngFor="let loader of skeletonLoaders">
          <ngx-skeleton-loader style="margin: 20px 0px; width: 100%" [theme]="skeletonTheme">
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>

    <div class="row screenshot-card-main-row db-style-1">
      <div class="col s6 m6 l6 xl4 screenshot-card" [ngStyle]="{
          display: PhotoList.length ? 'block' : 'none',
          visibility: PhotoList.length ? 'visible' : 'hidden'
        }" *ngFor="let image of PhotoList">
        <!-- <ng-container *ngFor="let imageInfo of image | keyvalue"> -->
        <div>
          <!-- *ngIf="imageInfo.key != '_links' && imageInfo.value.user_id !== '0'" -->
          <mat-card class="ss-card">

            <div class="row db-style-21">
              <div class="col s12 db-style-22">

                <a class=" screenshot_box waves-effect waves-light" href="{{ image.image_url }}"
                  data-fancybox="gallery">
                  <img src="{{ image.image_url }}" alt="screenshot image" class="responsive-img ss-img" />
                </a>

                <div class="absolute-info" *ngIf="isAdmin">
                  <button mat-mini-fab class="info-button" [matMenuTriggerFor]="menu" [ngStyle]="{transform: 'scale(0.8)'
              }">
                    <span class="material-symbols-outlined">more_vert</span>
                  </button>

                  <mat-menu #menu="matMenu">
                    <div mat-menu-item class="dropdown-menu-button" (click)="removeScreenShot(image)">
                      <span class="material-symbols-outlined delete"> delete </span>
                      <span class="delete">
                        &nbsp; &nbsp; Delete
                      </span>
                    </div>
                    <div mat-menu-item class="dropdown-menu-button" (click)="downloadScreenShot(image)">
                      <span class="material-symbols-outlined download"> download </span>
                      <span class="download">
                        &nbsp; &nbsp; Download
                      </span>
                    </div>
                  </mat-menu>
                </div>

                <div *ngIf="image.app_name" class="absolute-badge">
                  {{ trimName(image.app_name | slice:0:30) }}
                </div>
              </div>

            </div>

            <div class="row db-style-2">
              <div class="col s12 m6 l7 xl7 ss-card-profile-col" [routerLink]="['/user-details/', image.user_id ]">
                <div>
                  <user-profile [user]="getUserfromUserList(image.user_id)" [isName]="false"
                    [userImageClass]="userImageClass" [sizeAvatar]="34"></user-profile>
                </div>
                <div class="db-style-23">
                  <h4>{{ trimName(getUserName(image.user_id)) }}</h4>
                  @if (image.captured_time) {
                  <div class="screenshot-time-block" [matTooltip]="image.timeDisplay?.tooltip"
                    matTooltipClass="screenshot-time-tooltip" matTooltipShowDelay="400">
                    <p class="screenshot-time-primary">{{ image.timeDisplay?.primaryAbsolute || image.captured_time }}
                    </p>
                    @if (image.timeDisplay?.secondaryLine) {
                    <p class="screenshot-time-secondary">{{ image.timeDisplay.secondaryLine }}</p>
                    }
                  </div>
                  }
                </div>
              </div>
              <div class="col s12 m6 l5 xl5 badge-contain">
                <div class="badge">{{ image.type }}</div>
              </div>
            </div>
          </mat-card>
        </div>
        <!-- </ng-container> -->
      </div>

      <div *ngIf="total_ss == 0 && !loading" class="empty_list z-depth-2 remove-border" [ngStyle]="{
          display: !PhotoList.length ? 'block' : 'none',
          visibility: !PhotoList.length ? 'visible' : 'hidden'
        }">
        <img src="assets/images/empty_list.png" alt="empty list image" />
      </div>
    </div>

    <div class="pagination-div" *ngIf="total_ss != 0">
      <mat-paginator [length]="total_ss" [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]"
        aria-label="Select page" (page)="onPageChange($event)" #EmpPaginator>
      </mat-paginator>
    </div>
  </mat-card>

</div>

<app-loader *ngIf="loading"></app-loader>